import React from 'react';
import { Link } from 'react-router-dom';
import { Section } from './Section';
import { DEMO_URL } from '../data/links';
type StartHereProps = {
  n: string;
  body?: string;
};
const DEFAULT_BODY = 'Pick the workflow where being wrong costs the most. We compile it, you read the receipt. Thirty minutes. If it isn’t a fit, we’ll say so.';

/** The shared close: headline, one paragraph, two buttons, stacked left. */
export function StartHere({
  n,
  body = DEFAULT_BODY
}: StartHereProps) {
  return <Section n={n} label="Start here" className="start" data-id="element-278" data-mp="1sphku9uxdqjv">
      <div className="copy" data-id="element-279" data-mp="1smv5vp5pg8rm">
        <h2 className="h2" data-id="element-280" data-mp="26g4c5gycwe5x">Bring your highest standards.</h2>
        <p data-id="element-281" data-mp="26hntzbznux9t">{body}</p>
      </div>
      <div className="btns" data-id="element-282" data-mp="21pwatmiu3ttp">
        <a className="btn btn-lg btn-s" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-283" data-mp="21ol69khkei1j">
          Book a demo
        </a>
        <Link className="btn btn-lg btn-o" to="/contact" data-id="element-284" data-mp="1dyii3fgrtw87">
          Contact us
        </Link>
      </div>
    </Section>;
}